var $f9287d6029a971ac$exports = {};
// Elemen DOM
const $f9287d6029a971ac$var$commentList = document.getElementById('comment-list');
const $f9287d6029a971ac$var$commentInput = document.getElementById('comment-input');
const $f9287d6029a971ac$var$submitCommentButton = document.getElementById('submit-comment');
const $f9287d6029a971ac$var$membersList = document.getElementById('members-list');
const $f9287d6029a971ac$var$joinEventButtons = document.querySelectorAll('.join-event-btn');
// Fungsi untuk menampilkan komentar
function $f9287d6029a971ac$var$displayComments(comments) {
    $f9287d6029a971ac$var$commentList.innerHTML = ''; // Bersihkan komentar lama
    comments.forEach((comment)=>{
        const commentElement = document.createElement('li');
        commentElement.innerHTML = `
            <strong>${comment.username}</strong>: ${comment.text}
        `;
        $f9287d6029a971ac$var$commentList.appendChild(commentElement);
    });
}
// Fungsi untuk mengambil komentar dari API Netlify Functions
async function $f9287d6029a971ac$var$loadComments() {
    try {
        const response = await fetch('/api/getComments'); // Memanggil API Netlify Functions
        const comments = await response.json();
        $f9287d6029a971ac$var$displayComments(comments);
    } catch (error) {
        console.error('Error loading comments: ', error);
        alert('Failed to load comments: ' + error.message);
    }
}
// Fungsi untuk mengirimkan komentar baru ke API
async function $f9287d6029a971ac$var$handlePostComment() {
    const commentText = $f9287d6029a971ac$var$commentInput.value.trim();
    if (commentText) {
        const newComment = {
            username: 'Pengguna',
            text: commentText
        };
        try {
            const response = await fetch('/api/postComment', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(newComment)
            });
            if (!response.ok) throw new Error('Failed to post comment');
            $f9287d6029a971ac$var$loadComments(); // Memuat komentar setelah berhasil diposting
            $f9287d6029a971ac$var$commentInput.value = ''; // Kosongkan input
        } catch (error) {
            console.error('Error posting comment: ', error);
            alert('Failed to post comment: ' + error.message);
        }
    }
}
// Fungsi untuk menampilkan anggota komunitas
function $f9287d6029a971ac$var$displayMembers(members) {
    $f9287d6029a971ac$var$membersList.innerHTML = ''; // Bersihkan daftar anggota lama
    members.forEach((member)=>{
        const memberElement = document.createElement('div');
        memberElement.classList.add('community-member');
        memberElement.innerHTML = `
            <img src="${member.avatar}" alt="${member.username}" class="member-avatar">
            <strong>${member.username}</strong> - ${member.level} Level
        `;
        $f9287d6029a971ac$var$membersList.appendChild(memberElement);
    });
}
// Fungsi untuk mengambil anggota komunitas dari API
async function $f9287d6029a971ac$var$loadMembers() {
    try {
        const response = await fetch('/api/getMembers');
        const members = await response.json();
        $f9287d6029a971ac$var$displayMembers(members);
    } catch (error) {
        console.error('Error loading members: ', error);
        alert('Failed to load members: ' + error.message);
    }
}
// Fungsi untuk bergabung dalam acara komunitas
async function $f9287d6029a971ac$var$handleJoinEvent(event) {
    const eventName = event.target.previousElementSibling.innerText;
    alert(`Anda telah bergabung dalam acara: ${eventName}`);
    try {
        const response = await fetch('/api/joinEvent', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                eventName: eventName
            })
        });
        if (!response.ok) throw new Error('Failed to join event');
        alert('Anda berhasil bergabung dalam acara!');
    } catch (error) {
        console.error('Error joining event: ', error);
        alert('Failed to join event: ' + error.message);
    }
}
// Mengikat event listener ke tombol Kirim Komentar
$f9287d6029a971ac$var$submitCommentButton.addEventListener('click', $f9287d6029a971ac$var$handlePostComment);
// Mengikat event listener ke tombol Bergabung dalam acara
$f9287d6029a971ac$var$joinEventButtons.forEach((button)=>{
    button.addEventListener('click', $f9287d6029a971ac$var$handleJoinEvent);
});
// Load komentar dan anggota saat halaman dimuat
window.addEventListener('load', ()=>{
    $f9287d6029a971ac$var$loadComments();
    $f9287d6029a971ac$var$loadMembers();
});


//# sourceMappingURL=community.65fd7222.js.map
